import { render, staticRenderFns } from "./Preschool.vue?vue&type=template&id=262e8c8a&scoped=true"
import script from "./Preschool.vue?vue&type=script&lang=js"
export * from "./Preschool.vue?vue&type=script&lang=js"
import style0 from "./Preschool.vue?vue&type=style&index=0&id=262e8c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262e8c8a",
  null
  
)

export default component.exports